import http from './http-service';
let imageChecker = {};

imageChecker.isValidImage = async imagePath => {
  let response = await http.getStatic(imagePath);
  return response.headers.get('Content-Type').includes('image');
};

export default imageChecker;
